/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ListListParamsStatusEnum {
  Open = "open",
  Converted = "converted",
  Rejected = "rejected",
}

export enum EnrollmentsTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ForSchoolListParamsRepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum ForSchoolAggregateListParamsRepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum ActionEnum {
  Publish = "publish",
  Unpublish = "unpublish",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum SessionEnum {
  Am = "am",
  Pm = "pm",
}

export enum RelationsStatusEnum {
  Pending = "pending",
  Submitted = "submitted",
  Expired = "expired",
  Closed = "closed",
}

export enum ResultsStatusEnum {
  Pending = "pending",
  Submitted = "submitted",
  Closed = "closed",
  Resolved = "resolved",
  Rejected = "rejected",
  Expired = "expired",
}

export enum EntriesStatusEnum {
  Pending = "pending",
  Submitted = "submitted",
  Expired = "expired",
  Closed = "closed",
}

/** Enum containing the types of groups supported */
export enum GroupsGroupTypeEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export enum GroupsFrequencyEnum {
  Am = "am",
  Pm = "pm",
  AmPm = "am_pm",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum GroupsSessionEnum {
  Am = "am",
  Pm = "pm",
}

export enum GroupsSessionsEnum {
  Am = "am",
  Pm = "pm",
}

export enum PeriodsTypeEnum {
  Lesson = "Lesson",
  Registration = "Registration",
  Break = "Break",
  Activity = "Activity",
}

export enum PeriodsRegisterSessionEnum {
  Am = "am",
  Pm = "pm",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum GroupIdsSessionEnum {
  Am = "am",
  Pm = "pm",
}

/** Enum containing the types of groups supported */
export enum GroupsGroupTypeEnum1 {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export enum GroupsFrequencyEnum1 {
  Am = "am",
  Pm = "pm",
  AmPm = "am_pm",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum GroupsSessionEnum1 {
  Am = "am",
  Pm = "pm",
}

export enum GroupsSessionsEnum1 {
  Am = "am",
  Pm = "pm",
}

export enum PeriodsTypeEnum1 {
  Lesson = "Lesson",
  Registration = "Registration",
  Break = "Break",
  Activity = "Activity",
}

export enum PeriodsRegisterSessionEnum1 {
  Am = "am",
  Pm = "pm",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum GroupIdsSessionEnum1 {
  Am = "am",
  Pm = "pm",
}

/** Register session slot for a mark or grid row (AM or PM only). */
export enum ResultsSessionEnum {
  Am = "am",
  Pm = "pm",
}

export enum FrequenciesOffsetCycleEnum {
  Previous = "previous",
  Current = "current",
}

export enum FrequenciesOffsetCycleEnum1 {
  Previous = "previous",
  Current = "current",
}

export enum BillingPeriodsSpecOffsetCycleEnum {
  Previous = "previous",
  Current = "current",
}

export enum BillingPeriodsSpecOffsetCycleEnum1 {
  Previous = "previous",
  Current = "current",
}

export enum CurrencyEnum {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BYR = "BYR",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EEK = "EEK",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LTL = "LTL",
  LVL = "LVL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SKK = "SKK",
  SLE = "SLE",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  STD = "STD",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XCD = "XCD",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZMK = "ZMK",
  ZWD = "ZWD",
}

export enum InvoiceAggregatedListParamsByEnum {
  Default = "default",
  Date = "date",
  Paid = "paid",
  DueAmount = "due_amount",
  Overdue = "overdue",
  Projected = "projected",
  Total = "total",
  Discount = "discount",
  AgeGroup = "age_group",
  Payer = "payer",
  Count = "count",
  Payers = "payers",
  Students = "students",
}

export enum InvoiceAggregatedListParamsArrangeByEnum {
  AgeGroupIds = "age_group_ids",
  AgeGroup = "age_group",
  Month = "month",
  PayerIds = "payer_ids",
  ProductIds = "product_ids",
  Frequency = "frequency",
  DayPastDue = "day_past_due",
  Status = "status",
}

export enum InvoiceAggregatedListParamsBreakDownByEnum {
  Status = "status",
  Product = "product",
  ProductType = "product_type",
  Frequency = "frequency",
  AgeGroupIds = "age_group_ids",
  AgeGroup = "age_group",
}

export enum EntriesForSchoolAggregateListParamsArrangeByEnum {
  Student = "student",
}

export enum StatsForSchoolListParamsSchoolPropertyTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ReferenceTypeEnum {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ReferenceTypeEnum1 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ResultsStatusEnum1 {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsTypeEnum {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ForRelationDetailParamsStatusesEnum {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsTypeEnum1 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ResultsStatusEnum2 {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsTypeEnum2 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ForRelationHistoryListParamsStatusesEnum {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsStatusEnum3 {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsTypeEnum3 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ReferenceTypeEnum2 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ReferenceTypeEnum3 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ResultsStatusEnum4 {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ResultsTypeEnum4 {
  Signup = "signup",
  Event = "event",
  Message = "message",
}

export enum ItemsListParamsStatusesEnum {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum ForSchoolDetailParamsPlaceOfUseEnum {
  Application = "application",
  Profile = "profile",
}

export enum PlaceOfUseEnum {
  Application = "application",
  Profile = "profile",
}

export enum ForSchoolPublicListParamsPlaceOfUseEnum {
  Application = "application",
  Profile = "profile",
}

export enum PlaceOfUseEnum1 {
  Application = "application",
  Profile = "profile",
}

export enum ForParentListParamsEventTypeEnum {
  Default = "default",
  Period = "period",
  Holiday = "holiday",
}

export enum ForParentListParamsRepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum ForSchoolListParams1EventTypeEnum {
  Default = "default",
  Period = "period",
  Holiday = "holiday",
}

export enum ForSchoolListParams1RepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum EventTypeEnum {
  Default = "default",
  Period = "period",
  Holiday = "holiday",
}

export enum RepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum ActionEnum1 {
  Publish = "publish",
  Cancel = "cancel",
}

export enum ForSchoolAggregateListParams1EventTypeEnum {
  Default = "default",
  Period = "period",
  Holiday = "holiday",
}

export enum ForSchoolAggregateListParams1RepetitionTypeEnum {
  FirstOfRecurrence = "first_of_recurrence",
  NotRecurring = "not_recurring",
}

export enum ActionEnum2 {
  Open = "open",
  Draft = "draft",
  Close = "close",
}

export enum ConsentFormDetailParams1StatusesEnum {
  Agreed = "agreed",
  Declined = "declined",
  NoStatus = "no_status",
}

export enum AggregateListParamsArrangeByEnum {
  Subject = "subject",
  AgeGroup = "age_group",
}

export enum AggregateListParamsChartTypeEnum {
  Chart = "chart",
  Table = "table",
}

export enum GroupsTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum GroupsTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum GroupTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ActionEnum3 {
  Void = "void",
}

export enum ResultsTypeEnum5 {
  InvoiceItemDeleted = "invoice_item_deleted",
  InvoiceItemDiscountChanged = "invoice_item_discount_changed",
  InvoiceItemPriceChanged = "invoice_item_price_changed",
  InvoiceItemLabelChanged = "invoice_item_label_changed",
  InvoiceItemAccountChanged = "invoice_item_account_changed",
  InvoiceItemAdded = "invoice_item_added",
  InvoiceItemQuantityChanged = "invoice_item_quantity_changed",
  InvoicePayerChanged = "invoice_payer_changed",
  InvoiceDueDateChanged = "invoice_due_date_changed",
  InvoiceDateChanged = "invoice_date_changed",
  InvoiceVoided = "invoice_voided",
}

export enum ResultsStatusEnum5 {
  Unprocessed = "unprocessed",
  Reconciled = "reconciled",
  Unreconcilable = "unreconcilable",
  Failed = "failed",
}

export enum ResultsSourceEnum {
  FeeAssignmentDiscountChanged = "fee_assignment_discount_changed",
  FeeAssignmentPayerChanged = "fee_assignment_payer_changed",
  FeeAssignmentProductTypeChanged = "fee_assignment_product_type_changed",
  FeeAssignmentCancelled = "fee_assignment_cancelled",
  RegistrationStatusPeriodChanged = "registration_status_period_changed",
  ProductNameChanged = "product_name_changed",
  ProductPriceChanged = "product_price_changed",
  ProductLegalEntityChanged = "product_legal_entity_changed",
  ProductLegalEntityAccountChanged = "product_legal_entity_account_changed",
  InvoiceVoided = "invoice_voided",
  InvoiceEdited = "invoice_edited",
}

export enum InvoiceForSchoolListParamsByEnum {
  IssueDate = "issue_date",
  DueDate = "due_date",
  Discount = "discount",
  Students = "students",
  Paid = "paid",
  Due = "due",
  Overdue = "overdue",
  Projected = "projected",
  Status = "status",
  Total = "total",
}

export enum ProductsTypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum ProductsTriggerTypeEnum {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum YearlyProductAssignmentsProductTypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum YearlyProductAssignmentsPayerTypeEnum {
  Default = "default",
  Company = "company",
}

export enum ProductsForRelationDetailParamsTypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum ProductsPayerTypeEnum {
  Default = "default",
  Company = "company",
}

export enum ResultsTypeEnum6 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum ResultsTriggerTypeEnum {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum ProductsForSchoolDetailParamsTypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TriggersTriggerTypeEnum {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum TypeEnum1 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TriggersTriggerTypeEnum1 {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum TypeEnum2 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TriggersTriggerTypeEnum2 {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum TypeEnum3 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TriggersTriggerTypeEnum3 {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum TypeEnum4 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum TriggersTriggerTypeEnum4 {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum AssignmentsTypeEnum {
  Guardian = "guardian",
  Company = "company",
}

export enum SingleInvoiceTypeEnum {
  Guardian = "guardian",
  Company = "company",
}

export enum ResultsProductTypeEnum {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum ResultsPayerTypeEnum {
  Default = "default",
  Company = "company",
}

export enum InvoiceStatusEnum {
  Upcoming = "upcoming",
  Unpaid = "unpaid",
  PartiallyPaid = "partially_paid",
  Overdue = "overdue",
  Paid = "paid",
  Voided = "voided",
  Cancelled = "cancelled",
}

export enum ParentsOfStudentsCriteriaOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ParentsOfStudentsCriteriaOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StaffCriteriaOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StaffCriteriaOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ForSchoolAggregateListParams2ArrangeByEnum {
  ReadPercent = "read_percent",
  Month = "month",
  Creator = "creator",
}

export enum MessageCriteriaOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum MessageCriteriaOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ParentsOfStudentsCriteriaOperatorEnum2 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ParentsOfStudentsCriteriaOperatorEnum3 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StaffCriteriaOperatorEnum2 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StaffCriteriaOperatorEnum3 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ActionEnum4 {
  Publish = "publish",
  Submit = "submit",
  Unsubmit = "unsubmit",
}

export enum MessageCriteriaOperatorEnum2 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum MessageCriteriaOperatorEnum3 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum AvatarMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum AvatarMimeTypeEnum1 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum EnabledChannelsEnum {
  Email = "email",
  Whatsapp = "whatsapp",
}

export enum SubscribedTopicsEnum {
  Applications = "applications",
  Messages = "messages",
  Reports = "reports",
  Assessments = "assessments",
  Conduct = "conduct",
  Attendance = "attendance",
  Events = "events",
  Signups = "signups",
  Invoices = "invoices",
}

export enum KeyEnum {
  Month = "month",
  Metric = "metric",
}

export enum TotalNameEnum {
  Applied = "applied",
  Offered = "offered",
  Accepted = "accepted",
}

export enum RowsNameEnum {
  Applied = "applied",
  Offered = "offered",
  Accepted = "accepted",
}

export enum AdmissionsAggregateListParamsArrangeByEnum {
  Month = "month",
  Metric = "metric",
}

export enum EmploymentsTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EmploymentTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EmploymentTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EmploymentTypeEnum2 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EmploymentTypeEnum3 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EnrollmentsTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EnrollmentTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EnrollmentTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EnrollmentTypeEnum2 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ProductAssignmentsPayerTypeEnum {
  Default = "default",
  Company = "company",
}

export enum EnrollmentTypeEnum3 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum EnrollmentTypeEnum4 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ChildrenTypeEnum {
  Predefined = "predefined",
  Other = "other",
}

export enum ProductsTypeEnum1 {
  Recurring = "recurring",
  OneOff = "one_off",
}

export enum ProductsTriggerTypeEnum1 {
  RegistrationUpdate = "registration-update",
  SingleInvoice = "single-invoice",
}

export enum StudentsRolloverAggregateCreateParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsRolloverAggregateCreateParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsRolloverAggregateCreateParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StudentsRolloverAggregateCreateParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum InconsistencyTypeEnum {
  HaveRegistration = "have_registration",
  NoNextAgeGroup = "no_next_age_group",
  NoCurrentAgeGroup = "no_current_age_group",
  LeftOrLeaving = "left_or_leaving",
  NotEnrolled = "not_enrolled",
  SameAgeGroup = "same_age_group",
  RolloverInProcess = "rollover_in_process",
}

export enum ActionEnum5 {
  Publish = "publish",
  Unpublish = "unpublish",
}

export enum CurrencyEnum1 {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BYR = "BYR",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EEK = "EEK",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LTL = "LTL",
  LVL = "LVL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SKK = "SKK",
  SLE = "SLE",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  STD = "STD",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XCD = "XCD",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZMK = "ZMK",
  ZWD = "ZWD",
}

export enum SchoolLogoMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum TypeEnum5 {
  Regular = "regular",
  Additional = "additional",
  Other = "other",
}

export enum EducationSystemEnum {
  US = "US",
  UK = "UK",
  AU = "AU",
  BR = "BR",
}

export enum PropertiesTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum SchoolCurrencyEnum {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BYR = "BYR",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EEK = "EEK",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LTL = "LTL",
  LVL = "LVL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SKK = "SKK",
  SLE = "SLE",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  STD = "STD",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XCD = "XCD",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZMK = "ZMK",
  ZWD = "ZWD",
}

export enum SchoolMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum SchoolTypeEnum {
  Regular = "regular",
  Additional = "additional",
  Other = "other",
}

export enum SchoolEducationSystemEnum {
  US = "US",
  UK = "UK",
  AU = "AU",
  BR = "BR",
}

export enum PropertiesTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum CurrencyEnum2 {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BYR = "BYR",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EEK = "EEK",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LTL = "LTL",
  LVL = "LVL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SKK = "SKK",
  SLE = "SLE",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  STD = "STD",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XCD = "XCD",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZMK = "ZMK",
  ZWD = "ZWD",
}

export enum SchoolLogoMimeTypeEnum1 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum TypeEnum6 {
  Regular = "regular",
  Additional = "additional",
  Other = "other",
}

export enum EducationSystemEnum1 {
  US = "US",
  UK = "UK",
  AU = "AU",
  BR = "BR",
}

export enum DepartmentsTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum HousesTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum StatusesTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ParentSchoolRelationMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StatusesTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum HousesTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum DepartmentsTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum StaffSchoolRelationMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StudentSchoolRelationMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StaffSchoolRelationMimeTypeEnum1 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StaffSchoolRelationTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum InitialEmploymentTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum StaffSchoolRelationMimeTypeEnum2 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StaffSchoolRelationTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum InitialEmploymentTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum StudentSchoolRelationMimeTypeEnum1 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StudentSchoolRelationTypeEnum {
  Regular = "regular",
  ReEnrollment = "re_enrollment",
}

export enum InitialEnrollmentTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum StudentSchoolRelationMimeTypeEnum2 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum StudentSchoolRelationTypeEnum1 {
  Regular = "regular",
  ReEnrollment = "re_enrollment",
}

export enum InitialEnrollmentTypeEnum1 {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum ArrangeByAmountListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ArrangeByAmountListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ArrangeByAmountListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ArrangeByAmountListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ArrangeByAmountListParamsArrangeByEnum {
  Status = "status",
  House = "house",
  AgeGroup = "age_group",
}

export enum ParentMiniListListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ParentMiniListListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ParentMiniListListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ParentMiniListListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ParentsListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ParentsListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum ParentsListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum ParentsListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ResultsTypeEnum7 {
  Regular = "regular",
  ReEnrollment = "re_enrollment",
}

export enum StaffListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StaffListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StaffMiniListListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffMiniListListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffMiniListListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StaffMiniListListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StaffChartListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffChartListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StaffChartListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StaffChartListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StaffChartListParamsArrangeByEnum {
  AgeGroup = "age_group",
  Department = "department",
  Gender = "gender",
  House = "house",
  Nationality = "nationality",
  Status = "status",
  Subject = "subject",
  Group = "group",
}

export enum StaffChartListParamsBreakdownByEnum {
  AgeGroup = "age_group",
  Department = "department",
  Gender = "gender",
  House = "house",
  Nationality = "nationality",
  Status = "status",
  Subject = "subject",
  Group = "group",
}

export enum StudentMiniListListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentMiniListListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentMiniListListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StudentMiniListListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum ResultsTypeEnum8 {
  Regular = "regular",
  ReEnrollment = "re_enrollment",
}

export enum StudentsListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StudentsListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StudentsChartListParamsInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsChartListParamsNotInviteStatusEnum {
  NotInvited = "not_invited",
  Invited = "invited",
  Active = "active",
}

export enum StudentsChartListParamsOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum StudentsChartListParamsOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum StudentsChartListParamsArrangeByEnum {
  AgeGroup = "age_group",
  Gender = "gender",
  House = "house",
  Nationality = "nationality",
  Status = "status",
  TutorGroup = "tutor_group",
  Subject = "subject",
}

export enum StudentsChartListParamsBreakdownByEnum {
  AgeGroup = "age_group",
  Gender = "gender",
  House = "house",
  Nationality = "nationality",
  Status = "status",
  TutorGroup = "tutor_group",
  Subject = "subject",
}

export enum SchoolYearsOffsetCycleEnum {
  Previous = "previous",
  Current = "current",
}

export enum SchoolYearsOffsetCycleEnum1 {
  Previous = "previous",
  Current = "current",
}

export enum PeriodGroupsOffsetCycleEnum {
  Previous = "previous",
  Current = "current",
}

export enum PeriodGroupsOffsetCycleEnum1 {
  Previous = "previous",
  Current = "current",
}

export enum PeriodGroupsOffsetCycleEnum2 {
  Previous = "previous",
  Current = "current",
}

export enum PeriodGroupsOffsetCycleEnum3 {
  Previous = "previous",
  Current = "current",
}

export enum LeavingReasonTypeEnum {
  Predefined = "predefined",
  Other = "other",
}

export enum SchoolPropertiesTypeEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum SchoolPropertiesListParamsTypesEnum {
  Department = "department",
  Campus = "campus",
  House = "house",
  AgeGroup = "age_group",
  Status = "status",
}

export enum SchoolYearsOffsetCycleEnum2 {
  Previous = "previous",
  Current = "current",
}

export enum SchoolYearsOffsetCycleEnum3 {
  Previous = "previous",
  Current = "current",
}

export enum RecordsTypeEnum {
  Unknown = "unknown",
  Period = "period",
  Holiday = "holiday",
  Event = "event",
  Assessment = "assessment",
  AssessmentReport = "assessment_report",
}

export enum SchoolUserRelationsMimeTypeEnum {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}

export enum FilterOperatorEnum {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum FilterOperatorEnum1 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum FilterFrequencyTypesEnum {
  Weekly = "weekly",
  Monthly = "monthly",
  Termly = "termly",
  Biannually = "biannually",
  Annually = "annually",
  OneOff = "one_off",
}

export enum FilterDayPastDueEnum {
  AwaitingPayment = "awaiting_payment",
  PaidOnTime = "paid_on_time",
  PaidLessThan2WeeksLate = "paid_less_than_2_weeks_late",
  PaidLessThan4WeeksLate = "paid_less_than_4_weeks_late",
  PaidMoreThan4WeeksLate = "paid_more_than_4_weeks_late",
  OverdueByLessThan2Weeks = "overdue_by_less_than_2_weeks",
  OverdueByLessThan4Weeks = "overdue_by_less_than_4_weeks",
  OverdueByMoreThan4Weeks = "overdue_by_more_than_4_weeks",
}

export enum FilterOperatorEnum2 {
  All = "all",
  None = "none",
  Contains = "contains",
  IsEqual = "is_equal",
  InRange = "in_range",
  IsOneOf = "is_one_of",
}

export enum FilterOperatorEnum3 {
  All = "all",
  None = "none",
  Contains = "contains",
}

export enum FilterFrequencyTypesEnum1 {
  Weekly = "weekly",
  Monthly = "monthly",
  Termly = "termly",
  Biannually = "biannually",
  Annually = "annually",
  OneOff = "one_off",
}

export enum FilterDayPastDueEnum1 {
  AwaitingPayment = "awaiting_payment",
  PaidOnTime = "paid_on_time",
  PaidLessThan2WeeksLate = "paid_less_than_2_weeks_late",
  PaidLessThan4WeeksLate = "paid_less_than_4_weeks_late",
  PaidMoreThan4WeeksLate = "paid_more_than_4_weeks_late",
  OverdueByLessThan2Weeks = "overdue_by_less_than_2_weeks",
  OverdueByLessThan4Weeks = "overdue_by_less_than_4_weeks",
  OverdueByMoreThan4Weeks = "overdue_by_more_than_4_weeks",
}

export enum UserEnabledChannelsEnum {
  Email = "email",
  Whatsapp = "whatsapp",
}

export enum UserSubscribedTopicsEnum {
  Applications = "applications",
  Messages = "messages",
  Reports = "reports",
  Assessments = "assessments",
  Conduct = "conduct",
  Attendance = "attendance",
  Events = "events",
  Signups = "signups",
  Invoices = "invoices",
}

export enum AvatarMimeTypeEnum2 {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
}
